import { Link } from 'react-router-dom';
import { ArrowRight, Users, Anchor, Building2, Home } from 'lucide-react';
import SEO from '../components/SEO';
import { TRANSITION_SEGMENTS } from '../data/transitions';

const ICONS = {
  'commercial-cabin-crew': Users,
  'yacht-crew': Anchor,
  'hospitality': Building2,
  'private-household': Home,
};

const TransitionsIndexPage = () => (
  <div data-testid="transitions-index" className="min-h-screen bg-[#FDFBF7]">
    <SEO
      title="Transitions into Private Aviation — By Background | Gate 33"
      description="Private aviation hires from more places than most people think. Segment guides for commercial crew, yacht interior, hotels and fine dining, private households and villas."
      path="/transitions"
    />
    <section className="py-24">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <span className="overline inline-block mb-6">Where are you coming from?</span>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] mb-6 max-w-3xl mx-auto">
          Private aviation hires from more places than you think.
        </h1>
        <p className="text-lg text-[#1A1A1A] leading-relaxed max-w-2xl mx-auto">
          Pick the background closest to yours. Each guide names the strengths operators recognise, the gaps they still test for, and how to close them.
        </p>
      </div>
    </section>

    <section className="pb-24">
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        {TRANSITION_SEGMENTS.filter((s) => !s.hidden).map((s) => {
          const Icon = ICONS[s.slug] || Users;
          return (
            <Link
              key={s.slug}
              to={`/transitions/${s.slug}`}
              data-testid={`transitions-index-card-${s.slug}`}
              className="group bg-white border border-[#E5E0D8] p-8 md:p-10 hover:border-[#C5A880] transition-colors"
            >
              <Icon size={26} className="text-[#C5A880] mb-6" strokeWidth={1.5} />
              <span className="text-[10px] uppercase tracking-[0.22em] text-[#5A5A5A] font-semibold">Segment</span>
              <h2 className="font-heading text-2xl md:text-3xl text-[#0F0F0F] mt-2 mb-4 leading-tight">{s.label}</h2>
              <p className="text-[#5A5A5A] leading-relaxed mb-6">{s.tagline}</p>
              <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[#C5A880] font-semibold group-hover:gap-3 transition-all">
                See the transition <ArrowRight size={14} />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  </div>
);

export default TransitionsIndexPage;
